import type { SliderTypeContext } from '@/components/slider-type/context';
import { createContext } from 'react';

const Context = createContext<SliderTypeContext | null>(null);

Context.displayName = 'SliderTypeContext';

export default Context;
